import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Criteria from "./criteria";
import {toJS} from "../hocs/toJs";
import {formValueSelector} from "redux-form/immutable";

const selector = formValueSelector('sortCriteriaForm');

const parseCategories = (categories) => {
  const parsedCategories = [];
  categories.valueSeq().toArray().forEach( category => {
    parsedCategories.push({
      id: category.get('id'),
      name: category.get('name'),
      pillarId: category.get('pillarId'),
    })
  });
  return parsedCategories;
};

const parseDepartments = (departments) => {
  const parsedDepartments = [];
  departments.valueSeq().toArray().forEach( department => {
    parsedDepartments.push({
      id: department.get('id'),
      name: department.get('name'),
    })
  });
  return parsedDepartments;
};

const parseCriteria = (criteria) => {
  const parsedCriteria = [];
  criteria.valueSeq().toArray().forEach( criterion => (
    parsedCriteria.push({
      id: criterion.get('id'),
      name: criterion.get('name'),
      code: criterion.get('code'),
      weightOld: criterion.get('weightOld'),
      weightNew: criterion.get('weightNew'),
      weightNewComing: criterion.get('weightNewComing'),
      createdDate: criterion.get('createdDate'),
      categoryId: criterion.get('categoryId'),
      category: criterion.get('category')?{
        id: criterion.getIn(['category', 'id']),
        name: criterion.getIn(['category', 'name']),
        pillar: {
          id: criterion.getIn(['category', 'pillar', 'id']),
          name: criterion.getIn(['category', 'pillar', 'name']),
        }
      }:{},
      departmentId: criterion.get('departmentId'),
      department: criterion.get('department')?{
        id: criterion.getIn(['department', 'id']),
        name: criterion.getIn(['department', 'name'])
      }:{},
    })));
  return parsedCriteria;
};

class CriteriaHOC extends Component {

  componentDidMount() {
    this.props.getCategories({filter:{
        where: {or: [{deleted: false}, {deleted: null}]}
      }
    });
    this.props.getDepartments({filter: {where: {or: [{deleted: false}, {deleted: null}]}}});
    this.props.getCriteria({filter: {
        include: [{relation: 'category', scope: {include: 'pillar'}}, 'department'],
        where: {or: [{deleted: false}, {deleted: null}]}
      }
    });
  }


  render(){
    return (
      <Criteria
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    criteria: state.criteria.get('criteria'),
    loading: state.criteria.get('fetching'),
    categories: state.categories.get('categories'),
    departments: state.departments.get('departments'),
    criteriaErrors: state.criteria.get('errors'),
    deletingCriterion: state.criterion.get('deleting'),
    mobileViewSortBy: selector(state, 'sortBy'),
    mobileViewSortOrder: selector(state, 'sortOrder'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCriteria: (payload) => {
      dispatch(actions.getCriteria(payload))
    },
    getCategories: (payload) => {
      dispatch(actions.getCategories(payload))
    },
    getDepartments: (payload) => {
      dispatch(actions.getDepartments(payload))
    },
    changeCriteriaState: (payload) => {
      dispatch(actions.changeCriteriaState(payload))
    },
    getCriteriaWithFilters: (payload) => {
      dispatch(actions.getCriteriaWithFilters(payload))
    },
    deleteCriterion: (payload) => {
      dispatch(actions.deleteCriterion(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CriteriaHOC));



// WEBPACK FOOTER //
// ./src/components/criteria/criteriaHOC.js